import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/financialCenter',
        name: '财务中心',
        meta: {
            title: "财务中心",
        },
        redirect: '/financialCenter/incomeStatistics',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/financialCenter/incomeStatistics',
                name: "收入统计",
                meta: {
                    title: "收入统计",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/financialCenter/incomeStatistics.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/financialCenter/withdrawalStatistics',
                name: "提现统计",
                meta: {
                    title: "提现统计",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/financialCenter/withdrawalStatistics.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/financialCenter/marginWithdrawals',
                name: "保证金提现",
                meta: {
                    title: "保证金提现",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/financialCenter/marginWithdrawals.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/financialCenter/balanceWithdrawals',
                name: "余额提现",
                meta: {
                    title: "余额提现",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/financialCenter/balanceWithdrawals.vue'),
                    sidebar: Sidebar
                }
            },
        ]
    }
]